import { Link, useNavigate, useNavigation } from 'react-router-dom';
import { styled } from 'styled-components';
import { useState, useEffect } from 'react';
import Footer from '../components/footer/Footer';
import MembershipCard from './components/MembershipCard';
import PromotionService from '../../service/promotion/Promotion';
import PromotionAlert from './components/PromotionAlert';
import PageTop, { MainPageTop } from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';

const membershipData = [
  {
    title: 'Standard',
    description:
      '지금 사면 하루 1천 원 대로<br/>왕초보도 수익내는 경공매 물건 찾을 수 있어요!',
    special: [
      {
        img: '/assets/images/promotion/emoji_directhit.svg',
        text: '퀀트전략 VIP 리포트 분석 <strong>월 30건</strong> 제공',
      },
      {
        img: '/assets/images/promotion/emoji_money.svg',
        text: '나만의 알고리즘 분석/돈되는 물건 추천',
      },
      {
        img: '/assets/images/promotion/emoji_chart.svg',
        text: '경공매 다양한 테마로 무제한 검색',
      },
    ],
    prices: [
      {
        type: 'S',
        plan_id: 6,
        name: '전국 1개월 스탠다드 멤버십 얼리버드',
        plan_prc: 70000,
        is_discount: 'Y',
      },
      {
        type: 'S',
        plan_id: 7,
        name: '전국 3개월 스탠다드 멤버십 얼리버드',
        plan_prc: 190000,
        is_discount: 'Y',
      },
      {
        type: 'S',
        plan_id: 8,
        name: '전국 6개월 스탠다드 멤버십 얼리버드',
        plan_prc: 340000,
        is_discount: 'Y',
      },
      {
        type: 'S',
        plan_id: 9,
        name: '전국 12개월 스탠다드 멤버십 얼리버드',
        plan_prc: 600000,
        is_discount: 'Y',
      },
    ],
  },
  {
    title: 'Premium',
    description:
      '지금 사면 하루 4천 원 대로<br/>돈이 굴러 들어오는 경공매 물건 찾을 수 있어요!',
    special: [
      {
        img: '/assets/images/promotion/emoji_directhit.svg',
        text: '퀀트전략 VIP 리포트 분석 <strong>무제한</strong> 제공',
      },
      {
        img: '/assets/images/promotion/emoji_money.svg',
        text: '나만의 알고리즘 분석/돈되는 물건 추천',
      },
      {
        img: '/assets/images/promotion/emoji_chart.svg',
        text: '경공매 다양한 테마로 무제한 검색',
      },
    ],
  },
];

const EarlyBird = () => {
  const navigate = useNavigate();

  const [url, setUrl] = useState('');
  const [isAgree, setIsAgree] = useState(false);
  const [isAgree2, setIsAgree2] = useState(false);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [isDetailOpen2, setIsDetailOpen2] = useState(false);
  const [selected, setSelected] = useState(3);
  const [alertModal, setAlertModal] = useState(false);
  const [downloadAlert, setDownloadAlert] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const handleCopyAddress = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        alert('URL이 복사되었습니다!');
      })
      .catch((err) => {
        console.error('URL 복사에 실패했습니다:', err);
        alert('URL 복사에 실패했습니다.');
      });
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/assets/images/promotion/event_img.png';
    link.download = '부동산경매사이트_땅집고옥션_반값이벤트.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setDownloadAlert(true);
  };

  const isValidURL = (str: string): { valid: boolean; reason?: string } => {
    const urlRegex = /^(https?|ftp):\/\/(-\.)?([^\s\/?\.#-]+\.?)+(\/[^\s]*)?$/i;

    if (!/^https?:\/\//i.test(str)) {
      return {
        valid: false,
        reason:
          '유효하지 않은 URL입니다: http:// 또는 https://로 시작해야 합니다.',
      };
    }
    if (!urlRegex.test(str)) {
      return {
        valid: false,
        reason: '올바른 URL 형식이 아닙니다. 다시 확인해주세요.',
      };
    }

    return { valid: true };
  };

  const handleSubmitUrl = async () => {
    try {
      if (!url) return;

      if (!isAgree) {
        alert('개인정보 수집 및 이용에 동의하셔야 제출이 가능합니다.');
        return;
      }
      if (!isAgree2) {
        alert('개인정보 수집 및 이용에 동의하셔야 제출이 가능합니다.');
        return;
      }

      const result = isValidURL(url);
      if (!result.valid) {
        alert(result.reason);
        return;
      }

      const response = await PromotionService.promotion2(url);
      if (response) {
        setAlertModal(true);
        setUrl('');
      }
    } catch (error: any) {
      if (error.response?.data?.message === '이미 등록된 코드입니다.') {
        alert('이미 제출하셨습니다.');
        return;
      }
      alert(
        error.response?.data?.message ||
          '오류가 발생했습니다. 다시 시도해주세요.',
      );
      console.error('Error applying promotion:', error);
    }
  };

  return (
    <Component>
      <MainPageTop setOpenMenu={setOpenMenu} menu={true} />
      <Container>
        {/* <div style={{ background: '#FFFFFF' }}>
            <TopNav2 />
          </div> */}
        <TopBar>
          <TopBar_Inner>
            <img
              src="/assets/images/promotion/Logo1.svg"
              alt=""
              onClick={() => navigate('/')}
              style={{ height: '24px' }}
            />
            <img
              src="/assets/images/promotion/Share.svg"
              alt=""
              style={{ width: '34px', height: '34px' }}
              onClick={handleCopyAddress}
            />
          </TopBar_Inner>
        </TopBar>
        <Title_Banner>
          <Title_Badge_Wrap>
            <Title_Badge>지금 안 사면 손해! 정식 런칭 초특가 할인</Title_Badge>
          </Title_Badge_Wrap>
          <img
            src="/assets/images/promotion/EarlyBirdPromotion.png"
            alt=""
            style={{ width: '360px', height: '402px' }}
          />
        </Title_Banner>
        <Content2>
          <MemberShip_Wrap>
            <Jalnan>
              <span style={{ color: '#2323ff' }}>50% 할인</span>된 가격으로
              부동산 경공매 시작!
            </Jalnan>
            <Jalnan>
              소문내면{' '}
              <span style={{ color: '#2323ff' }}>
                100% 당첨 혜택
                <br /> + 커피 득템
              </span>{' '}
              기회까지
            </Jalnan>
          </MemberShip_Wrap>
        </Content2>
        <Content>
          <EventCount>EVENT 1</EventCount>
          <ContentTitleContainer>
            <Content_Title>
              <span>반값</span> 초특가 할인
            </Content_Title>
            <Description>
              지금 결제하면 50% 할인! 지금 사야 제일 싸요
              <br />
              지금 안 사면 손해! 할인받고 건물주되기 START
            </Description>
          </ContentTitleContainer>
          <MembershipContainer>
            <MembershipCard
              title={membershipData[0].title}
              description={membershipData[0].description}
              special={membershipData[0].special}
              prices={membershipData[0].prices}
              selected={selected}
              setSelected={setSelected}
            />
            <MembershipCard
              title={membershipData[1].title}
              description={membershipData[1].description}
              special={membershipData[1].special}
              isPremium
            />
          </MembershipContainer>
          <SmallDescription>
            *얼리버드 반값할인은 기간별 전국구 상품에만 해당됩니다.
          </SmallDescription>
        </Content>
        <Content bgColor="#ecf0ff">
          <EventCount>EVENT 2</EventCount>
          <ContentTitleContainer>
            <Content_Title>
              <span>100% 당첨</span>
              <br /> 소문내기 이벤트
            </Content_Title>
            <Description>
              참여만 해도 스탠다드 이용권 100% 제공
              <br />
              메가커피 100명 랜덤 증정
            </Description>
          </ContentTitleContainer>
          <ShareEventDateContainer>
            <ShareEventDateItem>
              <ShareEventDateTitle>
                <span>이벤트 기간</span>
              </ShareEventDateTitle>
              <ShareEventDateDetail>~ 2025. 07. 18 (금)</ShareEventDateDetail>
            </ShareEventDateItem>
            <ShareEventDateItem>
              <ShareEventDateTitle>
                <span>당첨자 발표</span>
              </ShareEventDateTitle>
              <ShareEventDateDetail>
                2025. 07. 25 (금) 개별연락
              </ShareEventDateDetail>
            </ShareEventDateItem>
          </ShareEventDateContainer>
          <Content_Title>소문내기 이벤트 혜택</Content_Title>
          <EventBenefit>
            <EventBenefitItem>
              <GiftWrapper>
                <BadgeIcon
                  src="/assets/images/promotion/100_winning.svg"
                  alt="100% 당첨"
                />
                <GiftCardImage
                  src="/assets/images/promotion/standard.png"
                  alt="Standard 10일 무료 이용권"
                />
              </GiftWrapper>
              <GiftDescription>
                <p style={{ margin: '0px' }}>스탠다드 10일 멤버십</p>
                <span>(참여자 전원)</span>
              </GiftDescription>
            </EventBenefitItem>
            <EventBenefitItem>
              <GiftWrapper>
                <BadgeIcon
                  src="/assets/images/promotion/100_drawing.svg"
                  alt="100% 당첨"
                />
                <GiftCardImage
                  src="/assets/images/promotion/mega_coffee.svg"
                  alt="메가커피 아메리카노"
                  mega
                />
              </GiftWrapper>
              <GiftDescription>
                <p style={{ margin: '0px' }}>메가커피 아메리카노</p>
                <span>(100명 추첨)</span>
              </GiftDescription>
            </EventBenefitItem>
          </EventBenefit>
          <ShareEventDescription>
            <ShareEventStepContainer>
              <ShareEventStep>
                <ShareEventStepNumber>
                  <span>1</span>
                </ShareEventStepNumber>
                <span>반값 이벤트 소문내기 이미지 다운받기</span>
              </ShareEventStep>
              <ImageDownload onClick={handleDownload}>
                <span>
                  이미지 다운로드
                  <img
                    src="/assets/images/promotion/download.svg"
                    alt=""
                    width={24}
                    height={24}
                  />
                </span>
              </ImageDownload>
            </ShareEventStepContainer>
            <ShareEventStepContainer>
              <ShareEventStep>
                <ShareEventStepNumber>
                  <span>2</span>
                </ShareEventStepNumber>
                <span>
                  본인 SNS 계정 (인스타그램, 페이스북, 블로그 등)에 작성하기
                </span>
              </ShareEventStep>
              <ShareEventSNS>
                <ShareEventSNSCheckList>
                  ・사진 업로드 필수
                </ShareEventSNSCheckList>
                <ShareEventSNSCheckList>
                  ・땅집고옥션 무료체험 후기 + 반값이벤트를 언급해주세요
                </ShareEventSNSCheckList>
                <ShareEventSNSCheckList>
                  ・제목과 본문에 아래 키워드 포함 필수
                </ShareEventSNSCheckList>
                <ShareEventSNSCheckList hashtag>
                  #부동산경매사이트 #부동산경매사이트추천 #땅집고옥션
                </ShareEventSNSCheckList>
              </ShareEventSNS>
            </ShareEventStepContainer>
            <ShareEventStepContainer>
              <ShareEventStep>
                <ShareEventStepNumber>
                  <span>3</span>
                </ShareEventStepNumber>
                <ShareEventStepTitle>
                  <span>게시글 URL 인증하기</span>
                  삭제 및 비공개 게시글은 인정되지 않습니다.
                </ShareEventStepTitle>
              </ShareEventStep>

              <ShareEventSubmitURLBox>
                <span>링크 제출</span>
                <ShareEventSubmitURL>
                  <ShareEventSubmitURLInput
                    placeholder="작성하신 게시글의 URL을 제출해주세요"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                  />
                  <ShareEventConfirmContainer>
                    <ShareEventConfirm>
                      <ShareEventConfirmButton
                        onClick={() => setIsAgree((prev) => !prev)}
                      >
                        <img
                          src={
                            isAgree
                              ? '/assets/images/check/circle-checked-blue.svg'
                              : '/assets/images/check/circle-checked-gray.svg'
                          }
                          alt=""
                          width={24}
                          height={24}
                        />
                        <span>개인정보 수집 및 이용 동의</span>
                      </ShareEventConfirmButton>
                      <img
                        src={
                          isDetailOpen
                            ? '/assets/images/arrow/ArrowTop24-light-gray.svg'
                            : '/assets/images/arrow/arrow-down-gray.svg'
                        }
                        alt=""
                        width={24}
                        height={24}
                        onClick={() => setIsDetailOpen((prev) => !prev)}
                      />
                    </ShareEventConfirm>
                    {isDetailOpen && (
                      <ShareEventConfrimDetail isOpen={isDetailOpen}>
                        개인정보보호법 규정에 따라 ‘땅집고옥션 얼리버드 반값’
                        이벤트에 신청하시는 분께 수집하는 개인정보의 항목, 개인
                        정보의 수집 및 이용 목적, 개인정보의 보유 및 이용기간을
                        안내 드리오니 자세히 읽은후 동의하여 주시길 바랍니다.
                        <br />
                        <br />
                        수집하는 개인정보의 항목 및 수집방법
                        <br /> 1) 수집하는 개인정보 항목 <br />
                        -이름, 연락처, 땅집고옥션 ID
                        <br />
                        <br />
                        2)개인정보 수집방법
                        <br /> -신청 접수 페이지
                        <br />
                        <br />
                        개인정보의 수집 및 이용 목적
                        <br /> 1) 본인확인 2)이벤트 경품 혜택 제공
                        <br />
                        <br />
                        개인정보의 보유 및 이용기간 <br />
                        이벤트 종료 이후 1개월 이내 파기
                      </ShareEventConfrimDetail>
                    )}
                  </ShareEventConfirmContainer>
                  <ShareEventConfirmContainer>
                    <ShareEventConfirm>
                      <ShareEventConfirmButton
                        onClick={() => setIsAgree2((prev) => !prev)}
                      >
                        <img
                          src={
                            isAgree2
                              ? '/assets/images/check/circle-checked-blue.svg'
                              : '/assets/images/check/circle-checked-gray.svg'
                          }
                          alt=""
                          width={24}
                          height={24}
                        />
                        <span>개인정보 제 3자 제공 동의</span>
                      </ShareEventConfirmButton>
                      <img
                        src={
                          isDetailOpen2
                            ? '/assets/images/arrow/ArrowTop24-light-gray.svg'
                            : '/assets/images/arrow/arrow-down-gray.svg'
                        }
                        alt=""
                        width={24}
                        height={24}
                        onClick={() => setIsDetailOpen2((prev) => !prev)}
                      />
                    </ShareEventConfirm>
                    {isDetailOpen2 && (
                      <ShareEventConfrimDetail isOpen={isDetailOpen2}>
                        개인정보 제 3자 제공 동의
                        <br /> 귀하는 제3자 제공에 대한 동의를 거부하실 수
                        있으나, 이는 이벤트 운영에 필수적인 절차이므로 동의하지
                        않으실 경우 참여가 제한될 수 있습니다.
                        <br />
                        <br />
                        제공받는 자 : 주식회사 엠딕
                        <br /> 제공받는 자의 이용 목적 : 1)본인확인 2) 이벤트
                        경품 혜택 제공 <br />
                        제공하는 항목 : 성함, 연락처, 땅집고옥션 ID 제공받는
                        자의 보유 및 이용기간 : 이벤트 종료 이후 1개월 이내 파기
                      </ShareEventConfrimDetail>
                    )}
                  </ShareEventConfirmContainer>
                  <ShareEventSubmitURLButton
                    disabled={!url}
                    onClick={handleSubmitUrl}
                  >
                    링크 제출하기
                  </ShareEventSubmitURLButton>
                </ShareEventSubmitURL>
              </ShareEventSubmitURLBox>
              <ShareSmallDescription>
                ※ 개인정보 수집 및 이용동의 대한 동의를 거부하실 수 있으나, 이는
                이벤트 운영에 필수적인 절차이므로 동의하지 않으실 경우 참여가
                제한될 수 있습니다.
              </ShareSmallDescription>
            </ShareEventStepContainer>
          </ShareEventDescription>
          <SmallDescription>
            <p>
              *경품 중 멤버십 이용권은 전국구 스탠다드 10일 상품으로 지급됩니다.
            </p>
            <p>
              *참여링크에 욕설, 비방 등 자사 내부 운영 기준에 위배되는 내용이
              포함된 경우 쿠폰 지급 대상에서 제외될 수 있으며 사전 고지 없이
              참여가 무효 처리될 수 있습니다.
            </p>
          </SmallDescription>
        </Content>

        <Footer_Container>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '24px',
            }}
          >
            <Footer_Title>이벤트 유의사항</Footer_Title>
            <Footer_Description>
              ・ ‘얼리버드 반값 할인’ 이벤트 기간 : ~7/18
              <br />
              ・ 본 이벤트는 땅집고옥션 회원이라면 누구나 참여 가능합니다.
              <br />・ 브랜드 사 재고 및 내부 사정으로 상품 혜택이 변경될 수
              있으며 이벤트는 고지없이 조기 마감 및 연장될 수 있습니다.
            </Footer_Description>
            <Footer_Title style={{ fontSize: '18px' }}>
              EVENT01 할인 이벤트
            </Footer_Title>
            <Footer_Description>
              ・땅집고옥션 회원이라면 누구나 ‘얼리버드 반값 할인’ 이벤트에
              참여하실 수 있습니다.
              <br />
              ・ 이벤트 기간 내에는 땅집고옥션 멤버십 정가(전국구 기준)에서 50%
              할인된 금액이 바로 적용되어 구매하실 수 있습니다.
              <br />・ 구매하신 멤버십 이용권은 6월 9일 부터 이용하실 수
              있습니다.
            </Footer_Description>
            <Footer_Title style={{ fontSize: '18px' }}>
              EVENT02 소문내기 이벤트
            </Footer_Title>
            <Footer_Description>
              ・소문내기 이벤트 기간 : ~7/18
              <br />
              ・상품 혜택 당첨자 선정 및 경품 발송 : 7/25 , 당첨자 개별연락
              <br />
              ・해당 이벤트는 1개의 아이디 당 1번만 참여 가능합니다.
              <br />
              ・전화번호 오/미기입으로 인한 재발송은 불가하니 회원가입 때 입력한
              전화번호가 맞는지 반드시 확인해주세요.
              <br />
              ・비공개/나만보기 등으로 설정하시면 확인이 어려우니 SNS 게시글
              ‘전체공개’로 업로드 하시길 바랍니다.
              <br />
              ・비정상적인 방법으로 참여 시 추첨대상에서 제외되며 예고없이 당첨
              취소될 수 있습니다. <br />
              (타인의 이미지 도용, 아이디 중복생성, 반복참여 프로그램 이용, 타
              이벤트 다중 참여용 계정 등)
              <br />
              ・커피 쿠폰 혜택은 랜덤 추첨을 우선으로 하며 발표 이후 선정 기준에
              대한 답변 및 응대는 제공하지 않음을 양해부탁드립니다.
              <br />
              ・멤버십 이용권 혜택은 100% 지급이나 욕설, 비방, 혐오표현, 허위
              정보 등 자사 내부 운영 기준에 위배되는 내용이 포함된 경우 사전
              고지 없이 참여가 무효 처리될 수 있습니다.
              <br />
              ・쿠폰 이용 정책은 발급 후 추후 안내 예정입니다.
            </Footer_Description>
          </div>
        </Footer_Container>
        <Footer />
        <PromotionAlert
          isOpen={downloadAlert}
          onClose={() => setDownloadAlert(false)}
          content="이미지 다운로드가 완료되었습니다."
        />
        <PromotionAlert
          isOpen={alertModal}
          onClose={() => setAlertModal(false)}
          content="이벤트 참여가 완료되었습니다."
        />
        {openMenu && <Menu page="main" setOpenMenu={setOpenMenu} />}
      </Container>
    </Component>
  );
};

const Footer_Description = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: calc(14px * -0.02);
  color: #b0b0b0;

  span {
    display: inline;
    text-decoration: underline;
    cursor: pointer;
    white-space: normal;
  }
`;

const Footer_Title = styled.div`
  font-family: Paperlogy;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #ffffff;
`;

const EventCount = styled.div`
  padding: 10px 28px;
  background-color: #2323ff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 9999px;
`;

const Confirm_Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Description = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  color: rgba(55, 56, 60, 0.61);
  text-align: center;
`;

const MembershipContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  gap: 40px;
`;

const Event = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
`;

const Footer_Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  background: #1f1f1f;
`;

const Content2 = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0px 543px; */
`;

const MemberShip_Wrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 320px;
  border-radius: 20px;
  padding: 24px 20px;
  gap: 8px;
  margin-bottom: 72px;
  background-color: #ffffff;
`;

const Jalnan = styled.div`
  text-align: center;
  font-family: Jalnan Gothic;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #222222;
  span {
    font-family: Jalnan Gothic;
    color: #2323ff;
  }
`;

const ContentTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Content_Title = styled.div`
  justify-content: center;
  align-items: center;

  font-family: Jalnan Gothic;
  font-weight: 400;
  font-size: 32px;
  line-height: 120%;
  text-align: center;
  color: #000000;
  span {
    font-family: Jalnan Gothic;
    color: #2323ff;
  }
`;
const Content = styled.div<{ bgColor?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 72px 20px;
  gap: 40px;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : '#ffffff')};
`;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Container = styled.div`
  background: linear-gradient(
    0deg,
    rgba(120, 179, 255, 1),
    rgba(219, 236, 255, 1),
    rgba(143, 188, 242, 1)
  );
  user-select: none;
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
`;

const TopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const TopBar_Inner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  align-items: center;

  img {
    height: auto;
    cursor: pointer;
  }
`;

const Title_Banner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
`;

const Title_Badge_Wrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title_Badge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-top: 2px solid #f2f8ff;
  border-bottom: 2px solid #f2f8ff;
  font-weight: 700;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
`;

const SmallDescription = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #37383c9c;

  p {
    text-align: left;
    margin: 0;
  }
`;

const ShareEventDateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 24px;
  padding: 24px;
  background-color: #142141;
`;
const ShareEventDateItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
const ShareEventDateTitle = styled.div`
  border-radius: 9999px;
  padding: 8px 24px;
  background-color: #ffffff;
  text-align: center;
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    color: #142141;
  }
`;

const ShareEventDateDetail = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 145%;
  color: #ffffff;
`;

const ShareEventDescription = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 24px;
  padding: 24px 20px;
  gap: 24px;
  background-color: #ffffff;
  box-shadow: 0px 4px 15px 0px #094c8426;
`;

const ShareEventStepContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

const ShareEventStepTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-weight: 500;
  font-size: 13px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #37383c9c;

  span {
    font-weight: 500;
    font-size: 16px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #222222;
  }
`;

const ShareEventStep = styled.div`
  display: flex;
  gap: 8px;
  font-weight: 500;
  font-size: 16px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #222222;
`;

const ShareEventStepNumber = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  background-color: #eff0ff;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  span {
    font-weight: 700;
    font-size: 12px;
    color: #2323ff;
  }
`;

const ShareEventStepDescription = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;

  span {
    font-weight: 700;
    font-size: 24px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #222222;
  }
`;

const ImageDownload = styled.button`
  width: 100%;
  border-radius: 16px;
  padding: 14px 60px;
  background-color: #2323ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  border: none;

  span {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    font-size: 16px;
    line-height: 145%;
    align-items: center;
    color: #ffffff;
  }
`;

const ShareEventSNS = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  gap: 8px;
  padding: 24px;
  background-color: #ecf0ff;
`;

const ShareEventSNSCheckList = styled.div<{ hashtag?: boolean }>`
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: ${({ hashtag }) => (hashtag ? '#2323ff' : '#222222')};

  user-select: text;
  -webkit-background-clip: text;
`;

const ShareEventSubmitURLBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #616161;
  }
`;

const ShareEventSubmitURL = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const ShareEventSubmitURLInput = styled.input`
  width: 100%;
  border-radius: 16px;
  padding: 24px 16px;
  gap: 10px;
  background-color: #f7f8fc;
  border: 1px solid #e1e2e4;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #616161;
  outline: none;
`;

const ShareEventSubmitURLButton = styled.button<{ disabled?: boolean }>`
  border-radius: 16px;
  padding: 14px 20px;
  background-color: ${({ disabled }) => (disabled ? '#F7F7F8' : '#2323FF')};
  font-weight: 500;
  font-size: 16px;
  text-align: center;
  color: ${({ disabled }) => (disabled ? '##37383C29' : '#FFFFFF')};
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  border: none;
`;

const ShareEventConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  padding: 16px;
`;

const ShareEventConfirm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  img {
    cursor: pointer;
  }
`;

const ShareEventConfirmButton = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  cursor: pointer;

  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 145%;
    letter-spacing: -2%;
    color: #222222;
  }
`;
const ShareEventConfrimDetail = styled.div<{ isOpen: boolean }>`
  border-radius: 16px;
  gap: 10px;
  padding: 12px;
  border: 1px solid #e1e2e4;
  background-color: #fafafb;
  color: #616161;
  max-height: ${({ isOpen }) => (isOpen ? '320px' : '0')};
  overflow-y: auto;
  white-space: pre-line;
  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  transition: all 0.4s ease;
`;

const ShareSmallDescription = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #37383c9c;
`;

const EventBenefit = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const EventBenefitItem = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  flex: 1;
`;

const GiftDescription = styled.div`
  font-weight: 700;
  font-size: 10px;
  line-height: 145%;
  letter-spacing: -2%;
  text-align: center;
  color: #222222;

  span {
    font-weight: 500;
    font-size: 10px;
    line-height: 145%;
    letter-spacing: -2%;
    text-align: center;
    color: #616161;
  }
`;

const GiftWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f3f6ff;
  border-radius: 50%;
`;

const BadgeIcon = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 30%;
  z-index: 10;
`;

const GiftCardImage = styled.img<{ mega?: boolean }>`
  width: ${({ mega }) => (mega ? '40%' : '70%')};
  height: auto;
  z-index: 1;
`;

export default EarlyBird;
